import { useState, useEffect, useCallback, useMemo } from "react";

import copy from "copy-to-clipboard";
import { ChevronDown } from "lucide-react";
import { InputGroup, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Button, DefaultTooltip, Input } from 'twyne-new.ui'

export default function URLGroup({ url, protocol, onProtocol }) {
  const [copied, setCopied] = useState(false)
  const [feedback, setFeedback] = useState("")

  const handleCopyURL = useCallback(() => {
    const copied = copy(url)
    setCopied(copied)
  }, [url])

  useEffect(() => {
    if (copied) {
      setFeedback("Copied!")
      setTimeout(() => setCopied(false), 2000)
    } else {
      setFeedback("Click to copy the url")
    }
  }, [copied])

  return <InputGroup>
    <Protocol value={protocol} onChange={onProtocol} />
    <DefaultTooltip content={feedback} triggerProps={{ className: 'w-full' }}>
      <Input readOnly value={url} onClick={handleCopyURL} className='w-full' />
    </DefaultTooltip>
  </InputGroup>
}

function Protocol({ value, onChange }) {
  const options = useMemo(() => [
    { label: 'Http', value: 'http' },
    { label: 'Https', value: 'https' },
  ], [])

  return <DropdownMenu size='sm'>
    <DropdownMenuTrigger asChild>
      <Button color='accent' size='sm' className='uppercase'>
        {value}
        <ChevronDown size={16} />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className='min-w-24'>
      {options.map(({ label, value }) => <DropdownMenuItem key={value} onClick={() => onChange(value)}>
        {label}
      </DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>
}
